'use client'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

const SHORTCUTS: { combo: string[]; description: string }[] = [
  { combo: ['Alt', 'Shift', 'A'], description: 'Otvori traku pristupačnosti' },
  { combo: ['Tab'], description: 'Prelaz na sledeći element' },
  { combo: ['Shift', 'Tab'], description: 'Prelaz na prethodni element' },
  { combo: ['Enter'], description: 'Aktivira dugme ili link' },
  { combo: ['Esc'], description: 'Zatvori otvoreni panel ili dijalog' },
  { combo: ['Razmak'], description: 'Uključi/isključi prekidač' },
]

interface Props {
  trigger: React.ReactNode
}

export function KeyboardShortcutsDialog({ trigger }: Props) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Tastaturne prečice</DialogTitle>
          <DialogDescription>
            Platformu možeš koristiti samo tastaturom. Evo najvažnijih prečica.
          </DialogDescription>
        </DialogHeader>

        <dl className="grid gap-3 sm:grid-cols-[auto_1fr]">
          {SHORTCUTS.map((s) => (
            <div key={s.description} className="contents">
              <dt className="flex flex-wrap items-center gap-1">
                {s.combo.map((key, i) => (
                  <span key={`${s.description}-${i}`} className="inline-flex items-center gap-1">
                    <kbd className="bg-muted rounded border px-2 py-0.5 text-xs font-medium">
                      {key}
                    </kbd>
                    {i < s.combo.length - 1 && (
                      <span aria-hidden="true" className="text-muted-foreground">
                        +
                      </span>
                    )}
                  </span>
                ))}
              </dt>
              <dd className="text-sm">{s.description}</dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  )
}
